import { commonService } from '.';

const getListMyManager = (idLang) => {
    return commonService.getWithParam('ListMyManager/all?idLang=' + idLang, null);
};

const getListEepManagerImminent = (body) => {
    return commonService.getWithParam('ListMyManager/eep', body);
};
const getListEepManagerAValider = (body) => {
    return commonService.getWithParam('ListMyManager/eepAValider', body);
};

const getListSearchMyManager = (body) => {
    return commonService.getWithParam('ListMyManager/recherche', body);
};

export const listMyManagerService = {
    getListMyManager,
    getListEepManagerImminent,
    getListEepManagerAValider,
    getListSearchMyManager
};
